var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Menu } from '@base-ui/react/menu';
import { Falcon } from 'modules/macro';
import { Loader } from 'modules/v2/feedback/Loader';
import { ScrollArea } from '../ScrollArea';
import { IconContainer, NestedItemIcon, StyledPositioner, StyledSubContent, StyledSubTrigger } from './styled';
export function MenuItemNested(props) {
    const { target, children, disabled, loading, open, onClose } = props, widthProps = __rest(props, ["target", "children", "disabled", "loading", "open", "onClose"]);
    const handleOnOpenChange = (newOpen) => {
        if (!newOpen) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    return (<Menu.SubmenuRoot open={open} onOpenChange={handleOnOpenChange}>
      <StyledSubTrigger disabled={disabled || loading}>
        {target}
        {loading ? (<IconContainer>
            <Loader size="xs"/>
          </IconContainer>) : (<NestedItemIcon>
            <Falcon $size={14} icon="caret-right" sourceConfig={{ family: 'classic', style: 'solid' }}/>
          </NestedItemIcon>)}
      </StyledSubTrigger>
      <Menu.Portal>
        <StyledPositioner collisionPadding={8}>
          <StyledSubContent {...widthProps}>
            <ScrollArea>{children}</ScrollArea>
          </StyledSubContent>
        </StyledPositioner>
      </Menu.Portal>
    </Menu.SubmenuRoot>);
}
